let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ilxRm")).then(() => parcelRequire('9yvvI'));